@for (pln of item.items; track pln.planningEntity.id) {
    <div
        class="planning offset-{{ pln.minutesOffset }} duration-{{ pln.duration }} {{
            pln.planningEntity.id !== pln.planning.planning_has_id ? 'secondary' : ''
        }}"
        [class.see-through]="ctrlKey"
        [class.use-once]="pln.planningEntity?.entity?.use_once"
        [class.highlight]="pln.planning === highlightedPlanning"
        [class.no-people]="isTeam && people.get(pln.planning.id) === 0"
        (click)="open(pln)">
        <div
            class="info status-{{ pln.planning.status_key }}"
            (mouseenter)="mouseEnter(pln, $event)"
            (mousemove)="mouseMove(pln, $event)"
            (mouseleave)="mouseLeave(pln)">
            <div class="main">
                <div class="time">
                    {{ pln.planningEntity.begindate | date: 'HH:mm' }} -
                    {{ pln.planningEntity.enddate | date: 'HH:mm' }} uur
                </div>
                <div class="name">
                    {{ pln.planningEntity.entity.use_once ? pln.planningEntity.entity.name : pln.planningEntity.name }}
                    @if (pln.planning.worknumber || pln.planning.afas_project_id) {
                        - {{ pln.planning.worknumber ?? pln.planning.afas_project_id }}
                    }
                </div>
            </div>
            <div class="other-info">
                @if (pln.planning.status_key === PlanningStatus.PlanningGeblokkeerd) {
                    <div class="description">
                        {{ pln.planning.description }}
                    </div>
                }
                <span class="ucfirst">{{ pln.planningEntity.driver }}</span
                ><br />
                {{ pln.planning.contractor }}<br />
            </div>
            @if (
                pln.planningEntity.entitytype_key !== 'rentalEquipment' &&
                pln.planningEntity.entitytype_key !== 'wipeTruck' &&
                ![PlanningStatus.PlanningSlaapdag, PlanningStatus.PlanningGeblokkeerd].includes(
                    pln.planning.status_key
                ) &&
                pln.planningEntity.entity_id != 900
            ) {
                <div class="d-flex">
                    <div class="tons flex-grow-1">{{ tons.get(pln.planning.id) }}</div>
                    <div class="trucks flex-grow-1">{{ trucks.get(pln.planning.id) }}</div>
                    @if (isTeam) {
                        <div class="people flex-grow-1">{{ people.get(pln.planning.id) }}</div>
                    }
                    <div class="daynight flex-grow-1" [class.night]="night.get(pln.planning.id)"></div>
                </div>
            }
        </div>
    </div>
}
@if (hourChoose !== null && (!isFixed || viewModel.addPlanningFixed)) {
    <div class="planning duration-{{ defaultDuration * 60 }} selector offset-{{ hourChoose }}" #timeChooseDiv></div>
}
@if (item.unavailableDays) {
    <div class="unavailable duration-{{ item.unavailableDays }}" (dblclick)="openEntityEdit()">Niet beschikbaar</div>
}
